module.exports = __webpack_public_path__ + "img/isdone.d8739757.png";